export default __webpack_public_path__ + "static/media/1889.db94347d.png";